@if (icon()) {
  <lucide-icon [img]="icon()"></lucide-icon>
}
